/**
 * BuildingIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BuildingIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.5 15.25a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5zm0-3a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5zm0-3a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5z" />
    <path
      fillRule="evenodd"
      d="M19.5 2.25A1.75 1.75 0 0 1 21.25 4v15a1 1 0 0 1-.007.096v1.154H22a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h.25V8A1.75 1.75 0 0 1 4 6.25h3.25V4A1.75 1.75 0 0 1 9 2.25zM4 7.75a.25.25 0 0 0-.25.25v12.25h4V19a.75.75 0 0 1 1.5 0v1.25h4V8a.25.25 0 0 0-.25-.25zm5-4a.25.25 0 0 0-.25.25v2.25H13A1.75 1.75 0 0 1 14.75 8v12.25h4.993V18a1 1 0 0 1 .007-.098V4a.25.25 0 0 0-.25-.25z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BuildingIcon = makeIcon('BuildingIcon', BuildingIconSvg)
